export const productsData = {
  data() {
    return {
      productsCategory: ["sony", "LG", "Samsung", "canon", "Toshibaa","sony2", "LG2", "Samsung2", "canon2", "Toshibaa2"],
      productsList: [
        {
          id: 1,
          code: "108",
          name: "دوربین کنون مدل ew2002",
          description: "متن توضیحات",
          images: [
            "https://dkstatics-public.digikala.com/digikala-products/1192481.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/quality,q_90",
            "https://dkstatics-public.digikala.com/digikala-products/1197336.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/quality,q_90",
          ],
          videos: ["aaa.mkv", "aaa.mkv"],
          category: "sony",
          saleMetodes: [
            { metode: "اجاره روزانه", price: 150000 },
            { metode: "اجاره ساعتی", price: 18000 },
          ],
          tags: ["دوربین", "دوربین دیجیتال", "تجهیزات "],
          attribute: [
            { title: "نوع حسگر ", value: "CMOS" },
            { title: "محدوده دقت حسگر", value: "20 مگاپیکسل و بیشتر" },
            { title: "محدوده زوم ", value: "10برابر بزرگنمایی" },
          ],
          score: 4.8,
          scoreReference: 45,
          suggestion: true,
          active: true,
        },
        {
          id: 2,
          code: "120",
          name: "بیربین کنون مدل ew2002",
          description: "متن توضیحات",
          images: [
            "https://dkstatics-public.digikala.com/digikala-products/638151.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/quality,q_90",
            "https://dkstatics-public.digikala.com/digikala-products/638652.png?x-oss-process=image/resize,m_lfit,h_800,w_800/quality,q_90",
          ],
          videos: ["aaa.mkv", "aaa.mkv"],
          category: "sony",
          saleMetodes: [
            { metode: "اجاره روزانه", price: 150000 },
            { metode: "اجاره ساعتی", price: 18000 },
          ],
          tags: ["دوربین", "دوربین دیجیتال", "تجهیزات "],
          attribute: [
            { title: "نوع حسگر ", value: "CMOS" },
            { title: "محدوده دقت حسگر", value: "20 مگاپیکسل و بیشتر" },
            { title: "محدوده زوم ", value: "10برابر بزرگنمایی" },
          ],
          score: 4.1,
          scoreReference: 14,
          suggestion: false,
          active: true,
        },
        {
          id: 3,
          code: "123",
          name: "بیربین کنون مدل ew2002",
          description: "متن توضیحات",
          images: [
            "https://images.unsplash.com/photo-1523275335684-37898b6baf30?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZHVjdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
            "https://images.unsplash.com/photo-1560343090-f0409e92791a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8cHJvZHVjdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
          ],
          videos: ["aaa.mkv", "bbb.mkv"],
          category: "sony",
          saleMetodes: [
            { metode: "اجاره روزانه", price: 150000 },
            { metode: "اجاره ساعتی", price: 18000 },
          ],
          tags: ["دوربین", "دوربین دیجیتال", "تجهیزات "],
          attribute: [
            { title: "نوع حسگر ", value: "CMOS" },
            { title: "محدوده دقت حسگر", value: "20 مگاپیکسل و بیشتر" },
            { title: "محدوده زوم ", value: "10برابر بزرگنمایی" },
          ],
          score: 3.7,
          scoreReference: 23,
          suggestion: false,
          active: true,
        },
      ],
    };
  },
  methods: {
    getSummaryProducts() {
      return this.productsList.slice(0, 5);
    },
    getProduct(products, productId) {
      return products.filter((List) => {
        return List.id == productId;
      });
      // return "Product ID:" + ProductId
    },
  },
};
